import { ReleaseNotesBundleService } from "./release-notes-bundle";

export * from "./release-notes-bundle";
